<template>
  <div class="base-informational-document" @click="expandDocument" :class="{ 'is-short': isShort }">
    <div class="base-informational-document__header">
      <BaseIcon class="base-informational-document__icon" :name="getDocumentIcon(document)" />
      <div v-if="!isShort" class="base-informational-document__title">
        {{ document.title }}
      </div>

      <BaseIcon v-if="!isShort" :name="chevronIcon" class="base-informational-document__chevron" />
    </div>
    <transition name="dropdown-basic" v-if="!isShort">
      <div v-if="expanded" class="base-informational-document__details">
        <div class="base-informational-document__details--content">
          <div v-if="document.format">
            <span>{{ $t('tender-details.document-format') }}</span
            >: {{ getDocumentFormat(document.format) }}
          </div>
          <div v-if="document.description">
            <span>{{ $t('tender-details.informations.description') }}</span
            >: {{ document.description }} <span v-if="document.format">({{ getDocumentFormat(document.format) }})</span>
          </div>
          <div v-if="document.documentType">
            <span>Type</span>:
            {{ $t(`document-type.${documentTypes[document.documentType]}`) }}
          </div>
          <div v-if="document.datePublished">
            <span>{{ $t('tender-details.informations.published-date') }}</span
            >:
            {{ formatStandardDate(document.datePublished) }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/*
 * This component is used to display document's information taken from various site.
 * User can't interact with this type of component, since it has only informational purpose.
 *
 */

import BaseIcon from '@/components/base/BaseIcon';
import { DOCUMENT_TYPES } from '@/models/document-types';
import { getDocumentFormat } from '@/util/document-file-util';
import { formatStandardDate } from '@/util/date-util';
import { getDocumentIcon } from '@/util/document-file-util';

export default {
  name: 'BaseInformationalDocument',
  components: {
    BaseIcon,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
    isShort: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    chevronIcon() {
      return this.expanded ? 'chevron-up' : 'chevron-down';
    },
    documentTypes() {
      return DOCUMENT_TYPES;
    },
  },
  methods: {
    getDocumentFormat,
    getDocumentIcon,
    formatStandardDate,
    expandDocument() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style lang="scss">
.base-informational-document {
  padding: 4px 8px;
  background: $color-neutral-pale;
  border-radius: $border-radius-medium;
  margin-bottom: 8px;
  font-size: $font-size-small;
  color: $color-normal;
  min-height: 28px;
  cursor: pointer;

  &.is-short {
    padding: 4px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $color-normal-pale;
    gap: 8px;
  }

  &__icon {
    flex: 0 0 auto;
    height: 18px;
    width: 18px;
    opacity: 0.3;
  }

  &__title {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__chevron {
    flex: 0 0 auto;
    width: 16px;
    transition: all 200ms ease;

    &:hover {
      color: $color-normal;
      transition: all 200ms ease;
    }
  }

  &__details {
    border-top: 1px solid $color-border;

    &--content {
      color: $color-normal-pale;
      padding-top: 8px;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }
}
</style>
